var map = {
	"./4-track-glockenspiel_55.webp": 74730,
	"./4-track-music-box_55.webp": 901,
	"./4-track-toy-piano_55.webp": 12304,
	"./dxtraterrestrial-1_55.webp": 8497,
	"./dxtraterrestrial-2_55.webp": 40382,
	"./edb-orgel_55.webp": 72852,
	"./elektrisk-salmesykkel_55.webp": 40902,
	"./lo-fi-tape-piano_55.webp": 22437,
	"./midnight-wurli_55.webp": 84709,
	"./omni-84_55.webp": 25605,
	"./strykebrett_55.webp": 36202,
	"./stylopoly_55.webp": 82198,
	"./subc_55.webp": 93108,
	"./voltage-controlled-cassette-organ_55.webp": 88671
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23971;